<template>
  <div>
    <div v-if="isAdmin" class="edit_uni_admins">
      <b-field label="Admins">
        <multiselect
          v-model="admins"
          :options="availableUsers"
          track-by="id"
          label="username"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="true"
          :preserve-search="true"
          placeholder="Choose admins to add/remove"
          :preselect-first="false"
        >
        </multiselect>
      </b-field>
      <b-button
        @click="editAdmins(false)"
        type="is-success"
        style="margin: 20px 20px 0"
      >
        Assign
      </b-button>
      <b-button
        @click="editAdmins(true)"
        type="is-danger"
        style="margin: 20px 20px 0 0"
        >Delete</b-button
      >
    </div>
    <div v-if="isAdmin" class="row columns">
      <div class="col-lg-3 col-sm-12 mt-3 d-flex align-items-center">
        <b-field label="University Groups">
          <multiselect
            v-model="uniGroups"
            :options="availableUniGroups"
            track-by="id"
            label="name"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="true"
            :preserve-search="true"
            placeholder="Choose uni group to add/remove"
            :preselect-first="false"
          >
          </multiselect>
        </b-field>
        <b-button
          class="mt-4"
          @click="openUniGroupSidebar(null)"
          type="is-success"
          >Add New</b-button
        >
        <b-button
          v-if="uniGroups.id"
          class="mt-4 mx-2"
          @click="openUniGroupSidebar(uniGroups.id)"
          type="is-success"
        >
          Edit
        </b-button>
        <b-button
          v-if="uniGroups.id"
          class="mt-4 mx-2"
          @click="editUniGroups(false)"
          type="is-success"
        >
          Assign
        </b-button>

        <b-button
          v-if="uniGroups.id"
          class="mt-4"
          @click="deleteUniGroups(uniGroups.id)"
          type="is-danger"
          >Delete</b-button
        >
      </div>
    </div>
    <div v-if="isManagement" class="row columns">
      <div class="col-lg-6 col-sm-12 mt-3 d-flex align-items-center">
        <b-field label="University Rules">
          <multiselect
            v-model="uniRules"
            :options="allGroupRules"
            track-by="id"
            label="name"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="true"
            :preserve-search="true"
            placeholder="Choose uni rules to add/remove"
            :preselect-first="false"
          >
          </multiselect>
        </b-field>
        <b-button
          v-if="uniRules.id"
          class="mt-4"
          @click="editUniGroups(false)"
          type="is-success"
        >
          Assign
        </b-button>
        <b-button
          v-if="uniRules.id"
          class="mt-4 mx-2"
          @click="opemUniRulesSidebar(uniRules)"
          >Edit</b-button
        >
        <b-button
          v-if="uniRules.id"
          class="mt-4"
          @click="editUniGroups(true)"
          type="is-danger"
          >Delete</b-button
        >
      </div>
      <div class="col-lg-6 col-sm-12 d-flex align-items-center">
        <b-field label="Add new university rule" class="column">
          <b-input
            v-model="newUniRule"
            type="text"
            name="newUniRule"
            @keyup.native.enter="addNewUniRule()"
          ></b-input>
        </b-field>
        <b-button class="mt-4 mx-2" @click="addNewUniRule()" type="is-success">
          Add new
        </b-button>
      </div>
    </div>
    <b-table
      :data="filteredUniversities"
      :mobile-cards="true"
      :checkable="isAdmin"
      :checked-rows.sync="checkedRows"
    >
      <template v-for="column in universityHeaders">
        <b-table-column v-bind="column">
          <template v-if="column.searchable" #searchable="props">
            <b-input
              v-if="column.field === 'university_admins'"
              v-model="adminSearchQuery"
              placeholder="Search..."
              icon="magnify"
              size="is-small"
            />
            <b-input
              v-else-if="column.field === 'universityGroup'"
              v-model="groupSearchQuery"
              placeholder="Search..."
              icon="magnify"
              size="is-small"
            />
            <b-input
              v-else-if="column.field === 'universityRules'"
              v-model="rulesSearchQuery"
              placeholder="Search..."
              icon="magnify"
              size="is-small"
            />
            <b-input
              v-else
              v-model="props.filters[props.column.field]"
              placeholder="Search..."
              icon="magnify"
              size="is-small"
            />
          </template>
          <template v-slot="props">
            <b-image
              v-if="column.field === 'img_url'"
              class="uni-logo"
              :src="props.row.img_url"
              alt=""
            ></b-image>
            <span v-else-if="column.field === 'universityGroup'">
              {{
                props.row[column.field]
                  ? props.row[column.field].name
                  : 'No group'
              }}
            </span>
            <span v-else-if="column.field === 'universityRules'">
              {{
                props.row[column.field]
                  ? props.row[column.field].name
                  : 'No rule'
              }}
            </span>
            <span v-else-if="column.field === 'university_admins'">
              {{
                props.row[column.field]
                  .map((uni) => uni.user.username)
                  .join(', ')
              }}
            </span>

            <span v-else>
              {{ props.row[column.field] }}
            </span>
          </template>
        </b-table-column>
      </template>

      <b-table-column
        field="actions"
        label="Actions"
        v-slot="props"
        width="260"
        v-if="isManagement"
      >
        <b-button
          tag="router-link"
          :to="'/add-uni/' + props.row.id"
          type="is-success"
          style="margin-right: 20px"
        >
          Edit
        </b-button>
        <b-button
          @click="deleteUniversity(props.row.id)"
          type="is-danger"
          style="margin-right: 20px"
          >Delete</b-button
        >
      </b-table-column>

      <template #empty>
        <div class="has-text-centered">No records</div>
      </template>
    </b-table>

    <b-sidebar
      class="uni-groups__sidebar"
      type="is-light"
      fullheight
      right
      v-model="rulesSidebar.isOpen"
      :can-cancel="false"
    >
      <b-field label="Rule name" class="column is-full">
        <b-input
          v-model="rulesSidebar.activeName"
          type="text"
          name="rules_name"
        ></b-input>
      </b-field>

      <b-field label="Course deadline" class="column is-full">
        <b-datepicker
          v-if="!deadlineTextMode"
          v-model="rulesSidebar.rules.deadline"
          locale="en-GB"
          :show-week-number="true"
          placeholder="Click to select..."
          icon="calendar-today"
          :icon-right="rulesSidebar.rules.deadline ? 'close-circle' : ''"
          icon-right-clickable
          @icon-right-click="clearDate"
          trap-focus
        >
        </b-datepicker>
        <b-input
          v-else
          v-model="rulesSidebar.rules.deadline"
          type="text"
          name="deadline_text"
        ></b-input>
        <b-icon
          title="Change deadline to text"
          @click.native.prevent="toggleDeadlineTextMode()"
          :icon="deadlineTextMode ? 'toggle-switch' : 'toggle-switch-off'"
          size="is-large"
          type="is-success"
        >
        </b-icon>
      </b-field>

      <b-field label="Student Finance" class="column is-full">
        <b-input
          v-model="rulesSidebar.rules.student_finance"
          type="text"
          name="student_finance"
        ></b-input>
      </b-field>

      <b-field label="Standard or Non-standard route" class="column is-full">
        <b-switch
          v-model="rulesSidebar.rules.standard_route"
          false-value="Standard route"
          true-value="Non-standard route"
          class="column is-full"
        >
          {{ rulesSidebar.rules.standard_route }}
        </b-switch>
      </b-field>

      <b-field label="Timetable" class="column is-full">
        <b-input
          placeholder="Use shift-enter for new line"
          type="textarea"
          v-model="rulesSidebar.rules.timetable"
          name="timetable"
        ></b-input>
      </b-field>

      <b-field label="Admission Proccess" class="column is-full">
        <b-input
          placeholder="Use shift-enter for new line"
          type="textarea"
          v-model="rulesSidebar.rules.admission_process"
          name="timetable"
        ></b-input>
      </b-field>

      <div class="column is-full">
        <label class="label">
          Timetable Options:
          <b-icon
            @click.native.prevent="rulesSidebar.rules.timetable_options = []"
            icon="lock-reset"
            size="is-small"
            type="is-danger"
            title="Reset timetable"
            class="cursor-pointer"
          ></b-icon>
        </label>
        <b-checkbox
          v-for="(timetable, tIndex) in timetableOptions"
          v-bind:key="tIndex"
          v-model="rulesSidebar.rules.timetable_options"
          :native-value="timetable"
        >
          {{ timetable }}
        </b-checkbox>
      </div>

      <div class="column is-full">
        <label class="label"> Documents: </label>
        <b-checkbox
          v-for="(document, dIndex) in customDocuments"
          v-bind:key="dIndex"
          v-model="rulesSidebar.rules.documents"
          :native-value="document.text"
        >
          {{ document.text }}
          <b-icon
            v-if="document.isRemovable"
            @click.native.prevent="removeCustomDocuments(dIndex, document)"
            icon="close"
            size="is-small"
            type="is-danger"
          >
          </b-icon>
        </b-checkbox>
        <b-field
          label="Add custom document"
          class="column is-full no-padding-left"
        >
          <b-input
            v-model="customDocument"
            @keyup.native.enter="addCustomDocument()"
            type="text"
            name="custom_doc"
          ></b-input>
        </b-field>
      </div>

      <div class="uni-groups__sidebar-footer">
        <b-button
          @click="closeUniRulesSidebar()"
          type="is-light"
          class="status-btn"
          >Cancel</b-button
        >
        <b-button
          @click="saveUniRulesChanges()"
          type="is-success"
          class="status-btn"
          >Save changes</b-button
        >
      </div>
    </b-sidebar>

    <b-sidebar
      class="uni-groups__sidebar"
      type="is-light"
      fullheight
      right
      v-model="newUniGroup.isOpen"
      :can-cancel="false"
    >
      <b-field label="Add new university group" class="column is-full">
        <b-input v-model="newUniGroup.name" type="text" name="name"></b-input>
      </b-field>
      <div
        v-for="(intake, index) in activeIntakes"
        :key="index"
        class="d-flex flex-wrap"
      >
        <span class="column is-full"> <b>Intake:</b> {{ intake.name }} </span>
        <b-field label="Bonus" class="column is-one-third">
          <b-input
            v-model="intake.price"
            type="number"
            name="newUniGroup"
          ></b-input>
        </b-field>

        <b-field label="Cecos" class="column is-one-third">
          <b-checkbox v-model="intake.notCounted"> </b-checkbox>
        </b-field>
        <b-field label="Is premium" class="column is-one-third">
          <b-checkbox v-model="intake.isPremium"> </b-checkbox>
        </b-field>
      </div>
      <div class="uni-groups__sidebar-footer">
        <b-button
          @click="closeUniGroupsSidebar()"
          type="is-light"
          class="status-btn"
          >Cancel</b-button
        >
        <b-button
          v-if="!newUniGroup.id"
          @click="addNewUniGroup()"
          type="is-success"
          class="status-btn"
          >Save changes</b-button
        >
        <b-button
          v-else
          @click="editUniversityGroup()"
          type="is-success"
          class="status-btn"
          >Edit uni group</b-button
        >
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import UniversityService from '../services/university.service';
import UtilService from '../services/util';
import Multiselect from 'vue-multiselect';
import moment from 'moment';

import { deadlineInvalidDates } from '../models/static';
export default {
  name: 'univeristy-list',
  components: {
    Multiselect,
  },
  data() {
    return {
      universities: [],
      availableUniGroups: [],
      allGroupRules: [],
      newUniGroup: {
        isOpen: false,
        name: '',
        id: null,
      },
      uniGroups: [],
      uniRules: [],
      newUniRule: '',
      admins: [],
      checkedRows: [],
      adminSearchQuery: '',
      groupSearchQuery: '',
      rulesSearchQuery: '',
      rulesSidebar: {
        isOpen: false,
        activeId: null,
        activeName: '',
        rules: {},
      },
      universityHeaders: [
        {
          field: 'universityGroup',
          label: 'Uni group',
          searchable: true,
        },
        {
          field: 'universityRules',
          label: 'Uni Rules',
          searchable: true,
        },
        {
          field: 'title',
          label: 'Uni name',
          searchable: true,
        },
        {
          field: 'address',
          label: 'Address',
          searchable: true,
        },
        {
          field: 'img_url',
          label: 'Logo',
        },
        {
          field: 'university_admins',
          label: 'Admins',
          searchable: true,
        },
      ],
      deadlineTextMode: false,
      timetableOptions: ['day', 'evening', 'weekend', 'blended'],
      customDocument: '',
      customDocuments: [
        {
          text: 'Passport',
          isRemovable: false,
        },
        {
          text: 'Diploma+Transcript',
          isRemovable: false,
        },
        {
          text: 'CV',
          isRemovable: false,
        },
        {
          text: 'Non standard route document',
          isRemovable: false,
        },
        {
          text: 'Personal Statement',
          isRemovable: false,
        },
        {
          text: 'Share Code',
          isRemovable: false,
        },
        {
          text: 'Proof of Address',
          isRemovable: false,
        },
        {
          text: 'Ask33 Consent Form',
          isRemovable: false,
        },
        {
          text: 'Checklist',
          isRemovable: false,
        },
        {
          text: 'SFE Pre-Application Screenshot',
          isRemovable: false,
        },
      ],
      activeIntakes: [],
    };
  },
  created() {
    this.retrieveUniversities();
    this.setActiveIntake();
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    availableUsers() {
      return UtilService.mappedUsers();
    },
    isAdmin() {
      return UtilService.isAdmin();
    },
    isManagement() {
      return UtilService.isManagement();
    },
    filteredUniversities() {
      if (!this.adminSearchQuery.length) {
        return this.universities;
      }
      return this.universities
        .filter((university) =>
          university.university_admins && university.university_admins.length
            ? university.university_admins.some((admin) =>
                admin.user.username
                  .toLowerCase()
                  .includes(this.adminSearchQuery.toLowerCase())
              )
            : true
        )
        .filter((university) =>
          university.universityGroup && this.groupSearchQuery
            ? university.universityGroup.name
                .toLowerCase()
                .includes(this.groupSearchQuery.toLowerCase())
            : true
        )
        .filter((university) =>
          university.universityRules && this.rulesSearchQuery
            ? university.universityRules.name
                .toLowerCase()
                .includes(this.rulesSearchQuery.toLowerCase())
            : true
        );
    },
  },
  methods: {
    async retrieveUniversities() {
      await UniversityService.getAll().then((response) => {
        this.universities = response.data.sort(
          (a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt)
        );
      });

      await UniversityService.findAllGroupRules().then((response) => {
        this.allGroupRules = response.data;
      });

      await UniversityService.findAllGroups().then((response) => {
        const mappedGroups = response.data
          .sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt))
          .map((group) => {
            return {
              id: group.id,
              name: group.name,
              intakes: group.uni_intakes.map((intake) => {
                return {
                  uniIntakeId: intake.id,
                  name: intake.intakeName.name,
                  price: intake.price,
                  notCounted: intake.notCounted,
                  isPremium: intake.isPremium,
                  intakeId: intake.intakeId,
                };
              }),
            };
          });
        this.availableUniGroups = mappedGroups;
        this.originalUniGroups = mappedGroups;
      });
    },

    combineArrays(array1, array2, shouldDelete) {
      // Initialize an empty array to hold the combinations
      const combinations = [];

      // Iterate over each element in the first array
      array1.forEach((item1) => {
        // Iterate over each element in the second array
        array2.forEach((item2) => {
          // Create a combination object with properties from both arrays
          const combination = {
            moderatorId: item1,
            universityId: item2,
            shouldDelete,
          };

          // Add the combination object to the combinations array
          combinations.push(combination);
        });
      });

      // Return the array of combinations
      return combinations;
    },

    editAdmins(shouldDelete) {
      if (!this.admins.length || !this.checkedRows.length) {
        this.$buefy.toast.open({
          duration: 3000,
          message: `Please select university and admins`,
          position: 'is-bottom',
          type: 'is-danger',
        });
        return;
      }

      const mappedAdminIds = this.admins.map((admin) => admin.id);
      const mappedUniIds = this.checkedRows.map((uni) => uni.id);
      const dataToSend = this.combineArrays(
        mappedAdminIds,
        mappedUniIds,
        shouldDelete
      );

      for (let index = 0; index < dataToSend.length; index++) {
        const elementData = dataToSend[index];
        UniversityService.updateUniAdmin(elementData).then(() => {
          if (dataToSend.length - 1 === index) {
            this.retrieveUniversities();
            this.checkedRows = [];
            this.admins = [];
          }
        });
      }
    },

    deleteUniversity(id) {
      UniversityService.delete(id).then(() => {
        const indexId = this.universities.indexOf(
          (university) => university.id === id
        );
        this.universities.splice(indexId, 1);
        this.$buefy.toast.open({
          duration: 3000,
          message: `University succesfully deleted`,
          position: 'is-bottom',
          type: 'is-success',
        });
      });
    },

    checkUniGroups(shouldCheckRows) {
      const valueToCheck = shouldCheckRows
        ? !this.uniGroups.length || !this.checkedRows.length
        : !this.newUniGroup.name.length;

      if (valueToCheck) {
        this.$buefy.toast.open({
          duration: 3000,
          message: `Please select university and its uni group`,
          position: 'is-bottom',
          type: 'is-danger',
        });
        return false;
      }

      return true;
    },

    addNewUniRule() {
      if (!this.newUniRule.length) {
        this.$buefy.toast.open({
          duration: 3000,
          message: `Please select a name for your new rule`,
          position: 'is-bottom',
          type: 'is-danger',
        });
        return false;
      }
      UniversityService.createUniRule({
        name: this.newUniRule,
      }).then((response) => {
        this.$buefy.toast.open({
          duration: 3000,
          message: `Added new uni rule: ${this.newUniRule}`,
          position: 'is-bottom',
          type: 'is-success',
        });
        this.newUniRule = '';
        this.allGroupRules.push(response.data);
      });
    },

    addNewUniGroup() {
      const intakes = this.activeIntakes.filter((intake) => intake.price > 0);
      if (this.checkUniGroups(false)) {
        UniversityService.createUniGroup({
          ...this.newUniGroup,
          intakes,
        }).then((response) => {
          this.$buefy.toast.open({
            duration: 3000,
            message: `Added new uni group: ${this.newUniGroup}`,
            position: 'is-bottom',
            type: 'is-success',
          });
          this.newUniGroup = '';
          this.availableUniGroups.push(response.data);
          this.$buefy.toast.open({
            duration: 3000,
            message: `Added new uni group`,
            position: 'is-bottom',
            type: 'is-success',
          });
          this.closeUniGroupsSidebar();
        });
      }
    },

    editUniversityGroup() {
      const intakes = this.activeIntakes.filter((intake) => intake.price > 0);
      if (this.checkUniGroups(false)) {
        UniversityService.updateUniGroup({
          ...this.newUniGroup,
          intakes,
        }).then(() => {
          this.retrieveUniversities();
          this.$buefy.toast.open({
            duration: 3000,
            message: `Uni group has been updated`,
            position: 'is-bottom',
            type: 'is-success',
          });
          this.closeUniGroupsSidebar();
        });
      }
    },

    openUniGroupSidebar(id) {
      if (id) {
        const group = this.availableUniGroups.find((group) => group.id === id);
        this.newUniGroup = {
          isOpen: true,
          id: group.id,
          name: group.name,
        };
        this.activeIntakes = [
          ...group.intakes,
          ...this.activeIntakes.filter(
            (intake) =>
              !group.intakes.some((gIntake) => gIntake.name === intake.name)
          ),
        ];
        // this.activeIntakes = group.intakes;
      } else {
        this.newUniGroup.isOpen = true;
      }
    },

    closeUniGroupsSidebar() {
      this.newUniGroup = {
        isOpen: false,
        id: null,
        name: '',
      };
      this.setActiveIntake();
    },

    setActiveIntake() {
      this.activeIntakes = this.$store.state.application_filter.intakes.map(
        (intake) => {
          return {
            id: intake.id,
            name: intake.name,
            price: 0,
            notCounted: false,
            isPremium: false,
          };
        }
      );
    },

    editUniGroups(shouldDelete) {
      if (
        (!this.uniGroups.id && !this.uniRules.id) ||
        !this.checkedRows.length
      ) {
        this.$buefy.toast.open({
          duration: 3000,
          message: `Please select university and uni groups or rules`,
          position: 'is-bottom',
          type: 'is-danger',
        });
        return;
      }

      const mappedUniIds = this.checkedRows.map((uni) => uni.id);
      const dataToSend = mappedUniIds.map((uniId) => {
        return {
          id: uniId,
          uniGroupId:
            this.uniGroups.id && !shouldDelete
              ? this.uniGroups.id
              : this.uniGroups.id && !shouldDelete
              ? null
              : false,
          uniGroupRuleId:
            this.uniRules.id && !shouldDelete
              ? this.uniRules.id
              : this.uniRules.id && !shouldDelete
              ? null
              : false,
        };
      });

      for (let index = 0; index < dataToSend.length; index++) {
        const elementData = dataToSend[index];
        UniversityService.updateUniversitiesInGroup(elementData).then(() => {
          if (dataToSend.length - 1 === index) {
            this.retrieveUniversities();
            this.checkedRows = [];
            this.admins = [];
          }
        });
      }
    },

    deleteUniGroups(id) {
      UniversityService.deleteGroup(id).then(() => {
        const indexId = this.availableUniGroups.indexOf(
          (group) => group.id === id
        );
        this.availableUniGroups.splice(indexId, 1);
        this.$buefy.toast.open({
          duration: 3000,
          message: `University group succesfully deleted`,
          position: 'is-bottom',
          type: 'is-success',
        });
      });
    },

    opemUniRulesSidebar(group) {
      let rules = {};
      let activeId = group.id;
      let activeName = group.name;

      if (group.rules) {
        const parsedRules = group.rules;
        rules = {
          ...parsedRules,
          deadline: this.getDeadline(parsedRules.deadline),
        };

        rules.documents &&
          rules.documents
            .filter(
              (x) =>
                !this.customDocuments
                  .map((document) => document.text)
                  .includes(x)
            )
            .forEach((element) => {
              this.customDocuments.push({
                text: element,
                isRemovable: true,
              });
            });
      } else {
        rules = {
          deadline: null,
          documents: [],
          timetable_options: [],
          offer: '',
          timetable: '',
          admission_process: '',
          student_finance: '',
          standard_route: 'Standard route',
        };
      }

      this.rulesSidebar = {
        isOpen: true,
        activeId,
        activeName,
        rules,
      };
    },

    closeUniRulesSidebar() {
      this.rulesSidebar = {
        isOpen: false,
        activeId: null,
        activeName: null,
        rules: {},
      };
    },

    saveUniRulesChanges() {
      UniversityService.updateGroupRule({
        id: this.rulesSidebar.activeId,
        name: this.rulesSidebar.activeName,
        rules: {
          ...this.rulesSidebar.rules,
          deadline: !this.deadlineTextMode
            ? moment(this.rulesSidebar.rules.deadline).format('DD-MM-YYYY')
            : this.rulesSidebar.rules.deadline,
        },
      }).then(() => {
        this.$buefy.toast.open({
          duration: 3000,
          message: 'Group Rules have been updated',
          position: 'is-bottom',
          type: 'is-success',
        });
        this.closeUniRulesSidebar();
      });
    },

    getDeadline(deadline) {
      if (
        deadlineInvalidDates.includes(
          deadline.toLowerCase().replace(/["']/g, '')
        )
      ) {
        this.deadlineTextMode = true;
        return deadline;
      }

      if (
        new Date(deadline).toString() !== 'Invalid Date' ||
        typeof deadline === 'string' ||
        deadline instanceof String
      ) {
        return moment(deadline.replaceAll('-', '/'), 'DD/MM/YYYY').toDate();
      }

      return null;
    },

    addCustomDocument() {
      this.customDocuments.push({
        text: this.customDocument,
        isRemovable: true,
      });
      this.customDocument = '';
    },

    removeCustomDocuments(index, document) {
      const indexToRemoveFromDocs =
        this.rulesSidebar.rules.documents.indexOf(document);

      if (indexToRemoveFromDocs > -1) {
        this.rulesSidebar.rules.documents.splice(indexToRemoveFromDocs, 1);
      }

      this.customDocuments.splice(index, 1);
    },

    toggleDeadlineTextMode() {
      this.rulesSidebar.rules.deadline = this.deadlineTextMode
        ? new Date()
        : '';
      this.deadlineTextMode = !this.deadlineTextMode;
    },

    clearDate() {
      this.rulesSidebar.rules.deadline = null;
    },
  },
};
</script>

<style>
.uni-logo {
  max-width: 80px;
}

.edit_uni_admins {
  display: flex;
  align-items: center;
}

.edit_uni_admins > .field {
  flex: auto;
}

.b-sidebar.uni-groups__sidebar .sidebar-content {
  width: clamp(400px, 500px, 50vw);
  padding-bottom: 60px;
}

.uni-groups__sidebar-footer {
  position: fixed;
  bottom: 0;
  background: white;
  padding: 8px 8px 8px 0;
}

.no-padding-left {
  padding-left: 0;
}
</style>
